/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useEffect } from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import { useForm } from "@/src/provider/Form/FormProvider";
import { getCaseLink } from "@/src/services/productService";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import EmailVerificationModal from "@/src/components/FormInfoModal/EmailVerificationModal";
import summaryStyle from "@/src/components/Form/ContractLaw/Summary/summaryStyle";
import SummaryDetailsItem from "@/src/components/Form/Common/SummaryDetailsItem/SummaryDetailsItem";

type SummaryProps = {
  product: AbstractCase;
  submitProps: FormSubmitProps;
};

const Summary = ({ product, submitProps }: SummaryProps) => {
  const location = useLocation();
  const stateField = location.state?.field;
  const { handleSubmit } = useForm();

  useEffect(() => {
    const el = document.getElementById(stateField);
    el && el.scrollIntoView();
  }, [stateField]);

  return (
    <ContentBox>
      <Typography variant={"h5"}>
        Ihre Angaben
      </Typography>
      <Grid container>
        <Box id={"generalCivilLawBase"} />
        <Grid sx={summaryStyle.subHeadline} size={12}>
          <Typography variant={"h6"}>Ihr Anliegen</Typography>
        </Grid>
        <SummaryDetailsItem fieldPath={"client.gender"} caseData={product} />
        <SummaryDetailsItem fieldPath={"client.givenName"} caseData={product} />
        <SummaryDetailsItem fieldPath={"client.familyName"} caseData={product} />

        <SummaryDetailsItem fieldPath={"customer.telephone"} caseData={product} />

        <Box id={"concernSummary"} />
        <Grid sx={summaryStyle.subHeadline} size={12}>
          <Typography variant={"h6"}>Zusammenfassung Ihres Anliegens</Typography>
        </Grid>
        <SummaryDetailsItem fieldPath={"personalTextMessage"} caseData={product} />
      </Grid>
      <form onSubmit={handleSubmit}>
        <FormSubmit
          sx={{ marginTop: "1rem" }}
          {...submitProps}
          hideBackButton={false}
          backLink={getCaseLink(product) + "/antrag/anliegen"}
          backText={"Alles bearbeiten"}
          nextText={"Angaben speichern"}
        />
      </form>
      <EmailVerificationModal />
    </ContentBox>
  );
};

export default Summary;
